module.exports = __webpack_public_path__ + "static/media/services.a5711c78.png";